export enum EDateSeparator {
    Default = " ",
    Slash = "/",
    Dash = "-",
    Dot = ".",
}